import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'product_tile-product_tile_on_touch_start-action_category_other';

/**
 * Tracks on touch start for a product tile which can be either on product tile click or as the user is scrolling.
 */
export function trackProductTileProductTileOnTouchStartActionCategoryOther(
  requestID_string: string,
  customParameterToken2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { requestID_string, customParameterToken2 },
  });
}
